import {useAuthStore} from "@src/stores/auth";
import "@src/services/echo";
import {db} from "@src/services/db";

export function KanbanUpdatedSessionListener() {
    const userStore = useAuthStore();

    const userId = userStore.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets
        .private(`user.${userId}`)
        .listen(".KanbanMoveSessionEvent", async (event: any) => {
            try {
                await db.sessions.update(event.session, {
                    kanban_card: event.kanban,
                    updated_at: new Date().toISOString()
                })
            } catch (e) {
                console.error("❌ erro no listener SessionFixedEvent", e);
            }
        });
}